// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetStickyHeaderVisibility = () => getClaimDefaultState().isStickyHeaderVisible;

const setStickyHeaderVisibility = (state, action) => action.isVisible;

export default (state = getClaimDefaultState().isStickyHeaderVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_NORMAL_STICKY_HEADER_VISIBILITY]: setStickyHeaderVisibility,
        [actions.RESET_CLAIM_NORMAL]: resetStickyHeaderVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/normal/reducers/is-sticky-header-visible.js